import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

export class FormCadastroPercursoCteOs extends Component {

    exibirPercursosSelecionados() {
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr className='text-center'>
                        <th colSpan='4'>Percursos CT-e OS</th>
                    </tr>
                    <tr>
                        <th>UF</th>                        
                        <th>Ordem</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {!this.props.percursoCteOS || this.props.percursoCteOS.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='4'>Nenhuma Percurso selecionado.
                            </td>
                        </tr>
                        : this.props.percursoCteOS.map((it, index) => (
                            <tr key={`percursocteOs-selecionado-${index}`}>
                                <td>{it.uf}</td>
                                <td>{it.ordem}</td>
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    {this.props.exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento() && <div
                                        onClick={(e) => {e.preventDefault(); this.props.removerPercursoCteOS(it.hash)}}
                                    >Remover
                                    </div>}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )
    }
   
    // eslint-disable-next-line class-methods-use-this
    exibirBotaoAdicionarPercursoCteOS() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="text-left">
                        <button data-toggle="modal"
                            data-target="#modalCadastrarPercursoCteOs"
                            className="btn btn-laranja" onClick={(e) => e.preventDefault()}>
                            Adicionar Percurso
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="col-12 col-sm-12 col-md-10 mt-2">
                    <div className='mb-2'>
                        {this.props.exibeBotaoSalvarCasoEmissaoCteOsSejaNovoOuHistoricoSejaIgualAErroOuEmPreenchimento() && this.exibirBotaoAdicionarPercursoCteOS()}
                    </div>

                    <div className="lista-table">
                        {this.exibirPercursosSelecionados()}
                    </div>
                </div>
            </div>
        )
    }
}


export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
    }
}

export default connect(mapStateToProps, {
})(reduxForm({
    form: 'formularioCadastroCteOS'
})(FormCadastroPercursoCteOs));